import React from 'react';
import CommonField from './CommonField.jsx';
import ToggleSwitch from '../../../../common/ToggleSwitch.jsx';
import get from 'lodash/get';

const ToggleSetting = (props) => {
  const { prefix = '', attr, label, selectedObject, setAttribute, defaultValue } = props;
  const fullAttr = [prefix, attr].filter(Boolean).join('.');
  const definedValue = get(selectedObject, fullAttr);
  const value = definedValue == null ? defaultValue : definedValue;

  return (
    <CommonField label={label} {...props} attr={fullAttr}>
      <ToggleSwitch
        name={`${selectedObject.id}-${fullAttr}`}
        isOn={value}
        handleToggle={() => setAttribute(fullAttr, !value)}
      />
    </CommonField>
  );
};

export default ToggleSetting;
